import { useFormatMessage } from '../../../../intl/intl';

export function useLang() {
  return {
    expires: useFormatMessage({ id: 'globals.expires' }),
    multiStore: useFormatMessage({ id: 'checkinCodeRT.labels.multi' }),
    singleStore: useFormatMessage({ id: 'checkinCodeRT.labels.single' }),
  };
}
